import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Fragment from 'react-dot-fragment';

import Icon from '../../../containers/assets/select-facility.png';

const Overlay = styled.div`
  position: fixed;
  z-index: 2000;
  left: 210px;
  top: 59px;
  width: calc(100vw - 210px);
  height: calc(100vh - 59px);
  background: rgba(0, 0, 0, 0.4);
`;

const Popup = styled.div`
  position: fixed;
  z-index: 2001;
  top: 230px;
  background: #ffffff;
  border-radius: 8px;
  width: calc(100vw - 810px);
  max-width: 590px;
  padding: 32px 40px;

  ${p => p.left && `
    left: ${p.left}px;
  `}
`;

const PopupArrow = styled.div`
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 15px solid #ffffff;
  position: fixed;
  z-index: 2001;
  top: 322px;

  ${p => p.left && `
    left: ${p.left}px;
  `}
`;

const ImageRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 24px;
`;

const Image = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 8px;
  background: #faeded;
  flex: 0 0 56px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 40px;
    height: 40px;
  }
`;

const Title = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);

  span {
    margin-left: 5px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;

    b {
      font-weight: 500;
      color: red;
    }
  }
`;

const Description = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 8px;
`;

const Button = styled.button`
  display: flex;
  outline: none;
  border: 0;
  margin: 24px 0 0;
  padding: 0;
  width: 100%;
  height: 40px;
  background: #5c91f5;
  border-radius: 4px;
  align-items: center;
  justify-content: center;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #ffffff;
`;

class SelectFacilityPopup extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      facilityPopup: props.facilityPopup,
      arrowLeftPosition: -1,
      popupLeftPosition: -1,
    };
  }

  componentDidMount() {
    this.checkPopupSize();

    window.addEventListener('resize', this.checkPopupSize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkPopupSize);
  }

  checkPopupSize = () => {
    const { facilityPopup } = this.state;

    if (facilityPopup) {
      this.setState({
        arrowLeftPosition: facilityPopup.offsetWidth + 255,
        popupLeftPosition: facilityPopup.offsetWidth + 270,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.facilityPopup !== prevProps.facilityPopup) {
      this.setState({
        facilityPopup: this.props.facilityPopup,
      }, () => {
        this.checkPopupSize();
      });
    }
  }

  confirm = () => {
    const { action } = this.props;

    if (action) {
      action();
    }
  }

  onClose = () => {
    const { close } = this.props;

    if (close) {
      close();
    }
  }

  render() {
    const { arrowLeftPosition, popupLeftPosition } = this.state;
    const { show } = this.props;

    return show ? (
      <Fragment>
        <Overlay onClick={this.onClose} />
        {arrowLeftPosition > -1 && <PopupArrow left={arrowLeftPosition} />}
        {popupLeftPosition > -1 && (
          <Popup left={popupLeftPosition}>
            <ImageRow>
              <Image>
                <img src={Icon} alt="select facility icon" />
              </Image>
              <div>
                <Title>
                  Select a Facility
                  <span><b>*</b> mandatory</span>
                </Title>
                <Description>
                  By selecting a facility, you now are able to produce products
                  and have inventories for sale.
                </Description>
              </div>
            </ImageRow>
            <Button onClick={this.confirm}>
              Yes, Confirm
            </Button>
          </Popup>
        )}
      </Fragment>
    ) : null;
  }

}

export default SelectFacilityPopup;



// WEBPACK FOOTER //
// ./src/components/operations/decisions/select-facility.js